export default __webpack_public_path__ + "static/media/mainImage.3ff5e518.png";